import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, getStation } from '../api';

// â”€â”€â”€ Step components â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

const TOTAL_STEPS = 6;

const DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

function ProgressBar({ step }) {
  return (
    <div style={{ marginBottom:32 }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
        {Array.from({length:TOTAL_STEPS},(_,i)=>(
          <div key={i} style={{ display:'flex', flexDirection:'column', alignItems:'center', flex:1 }}>
            <div style={{
              width:32, height:32, borderRadius:'50%', display:'flex', alignItems:'center',
              justifyContent:'center', fontWeight:700, fontSize:13,
              background: i<step ? '#6366f1' : i===step ? '#eef2ff' : '#f1f5f9',
              color: i<step ? '#fff' : i===step ? '#6366f1' : '#94a3b8',
              border: i===step ? '2px solid #6366f1' : '2px solid transparent',
              transition:'all 0.3s'
            }}>
              {i < step ? 'âœ“' : i+1}
            </div>
            {i < TOTAL_STEPS-1 && (
              <div style={{ position:'absolute' }} />
            )}
          </div>
        ))}
      </div>
      <div style={{ height:4, background:'#f1f5f9', borderRadius:2, marginTop:4 }}>
        <div style={{ height:'100%', background:'#6366f1', borderRadius:2,
          width:`${(step/TOTAL_STEPS)*100}%`, transition:'width 0.4s' }} />
      </div>
    </div>
  );
}

function StepCard({ title, subtitle, children }) {
  return (
    <div style={{ background:'#fff', borderRadius:16, padding:32, boxShadow:'0 4px 24px rgba(0,0,0,0.08)' }}>
      <div style={{ marginBottom:24 }}>
        <h2 style={{ fontSize:22, fontWeight:800, color:'#0f172a', margin:'0 0 6px' }}>{title}</h2>
        {subtitle && <p style={{ fontSize:14, color:'#64748b', margin:0 }}>{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

function Btn({ children, onClick, variant='primary', disabled, style, fullWidth }) {
  const base = { border:'none', borderRadius:10, fontWeight:700, fontSize:14,
    padding:'12px 24px', cursor:disabled?'not-allowed':'pointer',
    opacity:disabled?0.5:1, transition:'all 0.15s',
    width:fullWidth?'100%':undefined, ...style };
  const col = variant==='primary'  ? {background:'#6366f1',color:'#fff'}
            : variant==='success'  ? {background:'#16a34a',color:'#fff'}
            :                         {background:'#f1f5f9',color:'#374151'};
  return <button onClick={onClick} disabled={disabled} style={{...base,...col}}>{children}</button>;
}

function Input({ label, value, onChange, placeholder, type='text', hint }) {
  return (
    <div style={{ marginBottom:16 }}>
      <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>{label}</label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:'100%', padding:'11px 14px', border:'1.5px solid #e2e8f0', borderRadius:9,
          fontSize:14, outline:'none', boxSizing:'border-box',
          transition:'border-color 0.15s'}}
        onFocus={e=>e.target.style.borderColor='#6366f1'}
        onBlur={e=>e.target.style.borderColor='#e2e8f0'} />
      {hint && <div style={{ fontSize:12, color:'#94a3b8', marginTop:4 }}>{hint}</div>}
    </div>
  );
}

// â”€â”€â”€ Step 1: Welcome â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function StepWelcome({ onNext, station }) {
  return (
    <StepCard title="Welcome to Groovie Broadcast ðŸŽ™"
      subtitle="Let's get your station set up in under 5 minutes.">
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:28 }}>
        {[
          { icon:'ðŸ¤–', title:'AI Personas', desc:'Create voice personas trained on your broadcast style' },
          { icon:'ðŸŽµ', title:'Smart Schedule', desc:'Assign personas to program slots automatically' },
          { icon:'ðŸ’°', title:'Marketplace', desc:'License your personas to other broadcasters and earn' },
        ].map(f=>(
          <div key={f.title} style={{ background:'#f8fafc', borderRadius:12, padding:16, textAlign:'center' }}>
            <div style={{ fontSize:32, marginBottom:8 }}>{f.icon}</div>
            <div style={{ fontSize:13, fontWeight:700, color:'#0f172a', marginBottom:4 }}>{f.title}</div>
            <div style={{ fontSize:12, color:'#64748b', lineHeight:1.5 }}>{f.desc}</div>
          </div>
        ))}
      </div>
      {station && (
        <div style={{ background:'#eef2ff', borderRadius:10, padding:14, marginBottom:20, fontSize:13 }}>
          <span style={{ fontWeight:700, color:'#6366f1' }}>âœ“ Station registered:</span>
          <span style={{ color:'#374151', marginLeft:8 }}>{station.callsign} Â· {station.city}, {station.state}</span>
        </div>
      )}
      <Btn onClick={onNext} fullWidth>Get Started â†’</Btn>
    </StepCard>
  );
}

// â”€â”€â”€ Step 2: Confirm Station â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function StepStation({ onNext, onBack, station }) {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (station?.id) {
      api.get(`/broadcast/stations/${station.id}/status`).then(s=>setStatus(s)).catch(()=>{});
    }
  }, [station]);

  return (
    <StepCard title="Your Station" subtitle="Confirm your station details are correct before continuing.">
      {station ? (
        <div style={{ marginBottom:24 }}>
          {[
            { label:'Callsign', value:station.callsign },
            { label:'Location', value:`${station.city}, ${station.state}` },
            { label:'Format', value:station.format },
            { label:'Status', value:status?.status || 'Setting upâ€¦' },
          ].map(r=>(
            <div key={r.label} style={{ display:'flex', justifyContent:'space-between',
              padding:'12px 0', borderBottom:'1px solid #f1f5f9' }}>
              <span style={{ fontSize:13, color:'#64748b', fontWeight:600 }}>{r.label}</span>
              <span style={{ fontSize:13, color:'#0f172a', fontWeight:700 }}>{r.value}</span>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign:'center', padding:32, color:'#94a3b8' }}>
          No station found. Go to My Stations to add one.
        </div>
      )}
      <div style={{ display:'flex', gap:10 }}>
        <Btn onClick={onBack} variant='ghost' style={{ flex:1 }}>Back</Btn>
        <Btn onClick={onNext} disabled={!station} style={{ flex:2 }}>Looks Good â†’</Btn>
      </div>
    </StepCard>
  );
}

// â”€â”€â”€ Step 3: Consent â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function StepConsent({ onNext, onBack }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [agreed, setAgreed] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    if (!name || !email || !agreed) return;
    setLoading(true); setError(null);
    try {
      await api.post('/broadcast/dbp/consent', { full_name: name, email, consent_type: 'enrollment' });
      setDone(true);
      setTimeout(onNext, 1000);
    } catch(e) {
      if (e.message?.includes('already on file')) { setDone(true); setTimeout(onNext, 800); }
      else setError(e.message);
    }
    finally { setLoading(false); }
  };

  return (
    <StepCard title="Biometric Consent ðŸ“‹"
      subtitle="Required before voice enrollment. This protects your voice under BIPA regulations.">
      <div style={{ background:'#fffbeb', border:'1px solid #fde68a', borderRadius:10,
        padding:14, marginBottom:20, fontSize:13, color:'#92400e', lineHeight:1.6 }}>
        <strong>Why this matters:</strong> Your voice is biometric data. By consenting, you authorize
        Groovie to process your voice for AI persona creation. Your raw audio is deleted within 24 hours.
        You can withdraw consent at any time.
      </div>
      <Input label="Full Legal Name" value={name} onChange={setName} placeholder="Your full name" />
      <Input label="Email Address" type="email" value={email} onChange={setEmail} placeholder="your@email.com" />
      <label style={{ display:'flex', alignItems:'flex-start', gap:10, cursor:'pointer', marginBottom:20 }}>
        <input type="checkbox" checked={agreed} onChange={e=>setAgreed(e.target.checked)}
          style={{ marginTop:2, width:16, height:16, flexShrink:0 }} />
        <span style={{ fontSize:13, color:'#374151', lineHeight:1.5 }}>
          I consent to biometric voice data processing for AI persona creation. I understand I can
          withdraw consent at any time from my persona settings.
        </span>
      </label>
      {error && <div style={{ marginBottom:12, padding:10, background:'#fef2f2',
        borderRadius:8, fontSize:12, color:'#dc2626' }}>{error}</div>}
      {done && <div style={{ marginBottom:12, padding:10, background:'#f0fdf4',
        borderRadius:8, fontSize:12, color:'#16a34a' }}>âœ… Consent recorded! Continuingâ€¦</div>}
      <div style={{ display:'flex', gap:10 }}>
        <Btn onClick={onBack} variant='ghost' style={{ flex:1 }}>Back</Btn>
        <Btn onClick={submit} disabled={!name||!email||!agreed||loading||done} style={{ flex:2 }}>
          {loading ? 'Submittingâ€¦' : 'Submit Consent â†’'}
        </Btn>
      </div>
    </StepCard>
  );
}

// â”€â”€â”€ Step 4: Create Persona â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function StepCreatePersona({ onNext, onBack, setPersonaId }) {
  const [form, setForm] = useState({
    name: '', voice_name: '', voice_gender: 'neutral',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const save = async () => {
    if (!form.name || !form.voice_name) { setError('Name and on-air name required'); return; }
    setSaving(true); setError(null);
    try {
      const res = await api.post('/broadcast/dbp/personas', {
        name: form.name,
        voice_name: form.voice_name,
        voice_gender: form.voice_gender,
        description: `Created during onboarding`,
      });
      setPersonaId(res.persona.id);
      onNext();
    } catch(e) { setError(e.message); }
    finally { setSaving(false); }
  };

  return (
    <StepCard title="Create Your First Persona ðŸŽ™"
      subtitle="Give your AI broadcaster a name and voice identity.">
      <Input label="Persona Name (internal)" value={form.name} onChange={v=>set('name',v)}
        placeholder="e.g. Morning Marcus" hint="Used in your dashboard only" />
      <Input label="On-Air Voice Name" value={form.voice_name} onChange={v=>set('voice_name',v)}
        placeholder="e.g. Marcus Blaze" hint="The name listeners will hear" />
      <div style={{ marginBottom:20 }}>
        <div style={{ fontSize:13, fontWeight:600, color:'#374151', marginBottom:8 }}>Voice Gender</div>
        <div style={{ display:'flex', gap:10 }}>
          {['male','female','neutral'].map(g=>(
            <button key={g} onClick={()=>set('voice_gender',g)} style={{
              flex:1, padding:'10px 0', borderRadius:9, cursor:'pointer', fontWeight:600, fontSize:13,
              border:`2px solid ${form.voice_gender===g ? '#6366f1' : '#e2e8f0'}`,
              background: form.voice_gender===g ? '#eef2ff' : '#fff',
              color: form.voice_gender===g ? '#6366f1' : '#374151' }}>
              {g.charAt(0).toUpperCase()+g.slice(1)}
            </button>
          ))}
        </div>
      </div>
      <div style={{ background:'#f8fafc', borderRadius:10, padding:14, marginBottom:20, fontSize:12, color:'#64748b' }}>
        ðŸ’¡ You'll upload audio to train your persona's personality in the next step.
        A stand-in voice is used until your voice clone is ready.
      </div>
      {error && <div style={{ marginBottom:12, padding:10, background:'#fef2f2',
        borderRadius:8, fontSize:12, color:'#dc2626' }}>{error}</div>}
      <div style={{ display:'flex', gap:10 }}>
        <Btn onClick={onBack} variant='ghost' style={{ flex:1 }}>Back</Btn>
        <Btn onClick={save} disabled={saving} style={{ flex:2 }}>
          {saving ? 'Creatingâ€¦' : 'Create Persona â†’'}
        </Btn>
      </div>
    </StepCard>
  );
}

// â”€â”€â”€ Step 5: Upload Audio â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function StepUploadAudio({ onNext, onBack, personaId, onSkip }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const upload = async () => {
    if (!file || !personaId) return;
    setUploading(true); setError(null);
    try {
      const token = localStorage.getItem('broadcast_token');
      const BASE = process.env.REACT_APP_API_URL || 'https://groovie-business-api-production.up.railway.app/api/v1';
      const form = new FormData();
      form.append('audio_file', file);
      form.append('input_type', 'broadcast_recording');
      const res = await fetch(`${BASE}/broadcast/dbp/personas/${personaId}/train`, {
        method:'POST', headers:{Authorization:`Bearer ${token}`}, body:form,
      });
      if (!res.ok) { const e=await res.json().catch(()=>({})); throw new Error(e.detail||'Upload failed'); }
      const data = await res.json();
      setResult(data);

      // Also clone voice with same audio
      const form2 = new FormData();
      form2.append('audio_file', file);
      await fetch(`${BASE}/broadcast/dbp/personas/${personaId}/clone`, {
        method:'POST', headers:{Authorization:`Bearer ${token}`}, body:form2,
      }).catch(()=>{});

      setTimeout(onNext, 1500);
    } catch(e) { setError(e.message); }
    finally { setUploading(false); }
  };

  return (
    <StepCard title="Train Your Persona ðŸŽµ"
      subtitle="Upload 1-3 minutes of your broadcast audio. One upload trains your persona AND clones your voice.">
      <div style={{ border:'2px dashed #e2e8f0', borderRadius:12, padding:32, textAlign:'center',
        marginBottom:20, background: file ? '#f0fdf4' : '#f8fafc', cursor:'pointer',
        transition:'all 0.15s' }}
        onClick={()=>document.getElementById('onboard-audio').click()}>
        <input id="onboard-audio" type="file" accept="audio/*" style={{ display:'none' }}
          onChange={e=>setFile(e.target.files[0])} />
        <div style={{ fontSize:40, marginBottom:10 }}>{file ? 'âœ…' : 'ðŸŽµ'}</div>
        {file
          ? <div style={{ fontSize:14, fontWeight:700, color:'#16a34a' }}>{file.name}</div>
          : <>
              <div style={{ fontSize:14, fontWeight:600, color:'#374151', marginBottom:4 }}>
                Click to select audio
              </div>
              <div style={{ fontSize:12, color:'#94a3b8' }}>MP3, WAV, M4A Â· 1-3 minutes recommended</div>
            </>}
      </div>
      <div style={{ background:'#eff6ff', borderRadius:10, padding:12, marginBottom:20, fontSize:12, color:'#1e40af' }}>
        ðŸ”’ Raw audio is never stored â€” transcribed for personality extraction and deleted within 24 hours (BIPA compliant).
      </div>
      {error && <div style={{ marginBottom:12, padding:10, background:'#fef2f2',
        borderRadius:8, fontSize:12, color:'#dc2626' }}>{error}</div>}
      {result && <div style={{ marginBottom:12, padding:10, background:'#f0fdf4',
        borderRadius:8, fontSize:12, color:'#16a34a' }}>
        âœ… Training complete Â· {result.transcript_word_count} words Â· Profile updated. Continuingâ€¦
      </div>}
      <div style={{ display:'flex', gap:10 }}>
        <Btn onClick={onBack} variant='ghost' style={{ flex:1 }}>Back</Btn>
        <Btn onClick={onSkip} variant='ghost' style={{ flex:1 }}>Skip for Now</Btn>
        <Btn onClick={upload} disabled={!file||uploading} style={{ flex:2 }}>
          {uploading ? 'Processingâ€¦' : 'Upload & Train â†’'}
        </Btn>
      </div>
    </StepCard>
  );
}

// â”€â”€â”€ Step 6: First Program Slot â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function StepFirstProgram({ onNext, onBack, personaId, station }) {
  const [form, setForm] = useState({
    name: 'Morning Show', day_of_week: 1, start_time: '06:00', end_time: '10:00',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const save = async () => {
    setSaving(true); setError(null);
    try {
      await api.post('/radio-programs', {
        name: form.name,
        content_type: 'persona',
        day_of_week: parseInt(form.day_of_week),
        start_time: form.start_time,
        end_time: form.end_time,
        persona_id: personaId,
        channel_id: station?.channel_id || station?.id || 1,
        genres: [], mood: 'neutral', content_sequence: [],
      });
      onNext();
    } catch(e) { setError(e.message); }
    finally { setSaving(false); }
  };

  return (
    <StepCard title="Schedule Your First Show ðŸ“…"
      subtitle="Assign your persona to a time slot. You can add more slots later from Programs.">
      <div style={{ marginBottom:16 }}>
        <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>Program Name</label>
        <input value={form.name} onChange={e=>set('name',e.target.value)}
          style={{ width:'100%', padding:'11px 14px', border:'1.5px solid #e2e8f0',
            borderRadius:9, fontSize:14, outline:'none', boxSizing:'border-box' }} />
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:20 }}>
        <div>
          <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>Day</label>
          <select value={form.day_of_week} onChange={e=>set('day_of_week',e.target.value)}
            style={{ width:'100%', padding:'11px 12px', border:'1.5px solid #e2e8f0',
              borderRadius:9, fontSize:13, background:'#fff' }}>
            {DAYS.map((d,i)=><option key={i} value={i}>{d}</option>)}
          </select>
        </div>
        <div>
          <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>Start</label>
          <input type="time" value={form.start_time} onChange={e=>set('start_time',e.target.value)}
            style={{ width:'100%', padding:'11px 12px', border:'1.5px solid #e2e8f0',
              borderRadius:9, fontSize:13 }} />
        </div>
        <div>
          <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>End</label>
          <input type="time" value={form.end_time} onChange={e=>set('end_time',e.target.value)}
            style={{ width:'100%', padding:'11px 12px', border:'1.5px solid #e2e8f0',
              borderRadius:9, fontSize:13 }} />
        </div>
      </div>
      {error && <div style={{ marginBottom:12, padding:10, background:'#fef2f2',
        borderRadius:8, fontSize:12, color:'#dc2626' }}>{error}</div>}
      <div style={{ display:'flex', gap:10 }}>
        <Btn onClick={onBack} variant='ghost' style={{ flex:1 }}>Back</Btn>
        <Btn onClick={onNext} variant='ghost' style={{ flex:1 }}>Skip for Now</Btn>
        <Btn onClick={save} disabled={saving} style={{ flex:2 }}>
          {saving ? 'Savingâ€¦' : 'Schedule Show â†’'}
        </Btn>
      </div>
    </StepCard>
  );
}

// â”€â”€â”€ Main Onboarding Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export default function Onboarding() {
  const navigate = useNavigate();
  const station = getStation();
  const [step, setStep] = useState(0);
  const [personaId, setPersonaId] = useState(null);

  const next = () => setStep(s => Math.min(s+1, TOTAL_STEPS-1));
  const back = () => setStep(s => Math.max(s-1, 0));

  const finish = () => {
    localStorage.setItem('onboarding_complete', 'true');
    navigate('/dashboard');
  };

  const STEPS = [
    <StepWelcome onNext={next} station={station} />,
    <StepStation onNext={next} onBack={back} station={station} />,
    <StepConsent onNext={next} onBack={back} />,
    <StepCreatePersona onNext={next} onBack={back} setPersonaId={setPersonaId} />,
    <StepUploadAudio onNext={next} onBack={back} personaId={personaId} onSkip={next} />,
    <StepFirstProgram onNext={finish} onBack={back} personaId={personaId} station={station} />,
  ];

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg,#f8fafc 0%,#eef2ff 100%)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ width:'100%', maxWidth:560 }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:28, fontWeight:900, color:'#6366f1', cursor:'pointer' }} onClick={() => { window.location.href = 'https://groovie.live'; }} title="Groovie home">ðŸ“» Groovie Broadcast</div>
          <div style={{ fontSize:13, color:'#94a3b8', marginTop:4 }}>
            Step {step+1} of {TOTAL_STEPS}
          </div>
        </div>

        <ProgressBar step={step} />

        <div style={{ transition:'opacity 0.2s' }}>
          {STEPS[step]}
        </div>

        {/* Skip all */}
        {step > 0 && step < TOTAL_STEPS-1 && (
          <div style={{ textAlign:'center', marginTop:16 }}>
            <button onClick={finish} style={{ background:'none', border:'none',
              fontSize:12, color:'#94a3b8', cursor:'pointer', textDecoration:'underline' }}>
              Skip setup and go to dashboard
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
